<template>
  <div class="bs-action-wrapper" ref="tooltip"
       v-if="multiActionsParam.showMultiAction && (drillSet?.length || shoJumpActions?.length)"
       :style="style">
    <el-dropdown ref="dropDown">
      <span></span>
      <template #dropdown>
        <el-dropdown-menu>
          <el-dropdown-item @click="handleDrill(item,index)" v-for="(item, index) in drillSet" :key="index">
            {{ item.name || `路径${index + 1}` }}
          </el-dropdown-item>
          <el-dropdown-item @click="handleJump(item,index)" v-for="(item, index) in shoJumpActions" :key="index">
            {{ item.actionName }}
          </el-dropdown-item>
        </el-dropdown-menu>
      </template>
    </el-dropdown>
  </div>
  <el-breadcrumb style="z-index: 4" v-if="modelValue > -1" :separator-icon="ArrowRight" class="drill-nav">
    <el-breadcrumb-item>
      <span @click="updateIndex(-1)" class="cursor fs-12"
            :style="{ color: drillColor }"> {{ isDynamicDrill ? drillClickList?.[0].name : originDim.name }}</span>
    </el-breadcrumb-item>
    <el-breadcrumb-item v-for="(item, index) in modelValue + 1" :key="index">
				<span
            @click="updateIndex(index)"
            class="fs-12"
            :class="index !== modelValue && 'cursor'"
            :style="{ color: drillColor, opacity: index === modelValue && '0.7' }"
        >
					{{ getDrillName(index) }}
				</span>
    </el-breadcrumb-item>
  </el-breadcrumb>
  <Present v-if="showPresentMode" :theme="multiActionsParam.themeCfg" :isDark="multiActionsParam.isDark" :prop="prop"
           :option="option"></Present>
</template>

<script setup>
import {ArrowRight} from "@element-plus/icons-vue";
import {computed, nextTick, ref, watch} from "vue";
import {cloneDeep} from "lodash-es";
import {useEventListener} from "@vueuse/core";
import {useDebounceFn} from "@vueuse/core";
import Present from './presentMode.vue'

let emit = defineEmits(['update:modelValue', 'multiJump', 'multiDrill'])
let props = defineProps({
  modelValue: {},
  prop: {},
  option: {},
  multiActionsParam: {},
  getDrillITem: {
    default() {
      return function () {
        return ''
      }
    }
  },
  drillDimList: {},
  drillClickList: {},
  currentDrillRouteIndex: {
    default: -1
  }
})
const isDynamicDrill = computed(() => {
  return props.multiActionsParam.thisArg.dynamicDrill;
})
const showPresentMode = computed(() => {
  return props?.multiActionsParam?.themeCfg?.presentMode && !props.prop.presentDisabled && props?.multiActionsParam?.component?.prop !== 'indexCard';
})

function getDrillName(index) {
  if (isDynamicDrill.value) {
    index++
    let item = props.drillClickList[index]
    return index === props.drillClickList.length ? '当前' : item.name
  } else {
    return props.drillDimList[index].name
  }
}

let dropDown = ref()
// 需要显示操作弹窗 有这两个配置说明是新版配置
let drillSet = computed(() => {
  let set = props.prop?.dimensions?.[0]?.set;
  return set?.drillActions || [];
})

let shoJumpActions = computed(() => {
  const {
    currentShowJumpAction
  } = props.prop
  if (currentShowJumpAction) {
    return currentShowJumpAction
  } else {
    return props.prop?.jumpActions
  }
})
const debouncedFn = useDebounceFn(() => {
  if (props.multiActionsParam.showMultiAction) {
    // 只有一个默认选中 不弹窗展示
    if (drillSet.value.length + (props.prop?.jumpActions?.length || 0) === 1) {
      if (drillSet.value.length === 1) {
        handleDrill(drillSet.value[0], 0)
      } else {
        handleJump(props.prop.jumpActions[0], 0)
      }
    } else {
      nextTick(() => {
        dropDown.value?.handleOpen()
      })
    }
  }
}, 100);
watch(() => props.multiActionsParam.showMultiAction, debouncedFn)


function handleDrill(item, index) {
  emit('multiDrill', item, index)
}

function handleJump(item, index) {
  emit('multiJump', item, index)
}

let style = computed(() => {
  props.multiActionsParam.showMultiAction = false
  nextTick(() => {
    props.multiActionsParam.showMultiAction = true
  })
  return {
    left: props.multiActionsParam.clickParams.offsetX + 'px',
    top: props.multiActionsParam.clickParams.offsetY + 'px',
  };
})
let tooltip = ref()

function updateIndex(index) {
  emit('update:modelValue', index)
}

let drillColor = computed(() => {
  if (props.prop?.dimensions?.length && props.prop.dimensions?.[0]?.set?.drillActions?.length) {
    return props.prop.dimensions[0]?.set?.drillActions[props.currentDrillRouteIndex]?.drillLabelColor || "#3e7aff";
  }
  return "#3e7aff";
});
let originDim = cloneDeep(props.prop.dimensions?.[0]);
// useEventListener(document, "click", (e) => {
//   if (!props.multiActionsParam.clickChart) {
//     if (!tooltip.value.contains(e.target)) {
//       props.multiActionsParam.showMultiAction = false
//     }
//   } else {
//     props.multiActionsParam.clickChart = false
//   }
// });
</script>

<style scoped>
.drill-nav {
  padding-left: 30px;
  height: 20px;
  position: relative;
  z-index: 5;
}

</style>
<style lang="scss">
.drill-nav {
  .el-breadcrumb__separator {
    color: var(--el-text-color-placeholder);
  }

  .el-breadcrumb__item {
    font-size: 16px;

    .el-form-item__label {
      color: var(--el-text-color-regular)
    }
  }
}

.bs-action-wrapper {
  position: absolute;
}
</style>